// extracted by mini-css-extract-plugin
export default {"root":"yYMNxAJ7_G","thumbnail":"X0_GzbI53e","likeStatContainer":"pehysax1Jd","stats":"nhIgpptGTA"};